import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Media Queries/width";
import * as React from 'react';
export default {
  Content,
  React
};